// extracted by mini-css-extract-plugin
module.exports = {"dot":"dot__2ujBU"};